import { render, staticRenderFns } from "./CompareAssessment.vue?vue&type=template&id=213b27ce"
import script from "./CompareAssessment.vue?vue&type=script&lang=js"
export * from "./CompareAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports